module.exports = __webpack_public_path__ + "img/PARTYPOKER.24b69ea6.svg";